import { HAS_GROUPING_CHARS_ID, HAS_GROUPING_CHARS_TITLE } from '../../constants';
import { createCheckboxFilter } from './createCheckboxFilter';

export const createHasGroupingCharacteristicsFilter = () =>
    createCheckboxFilter({
        id: HAS_GROUPING_CHARS_ID,
        title: HAS_GROUPING_CHARS_TITLE,
    });
